module.exports = __webpack_public_path__ + "static/media/Aquecimento.bc3dc01c.png";